import React from 'react';
import { Modal } from '@/components/base';

export interface PatientFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Patient Form Modal - Uses the base Modal component for consistent styling
 * with other modals like ScheduleAppointmentModal
 */
export const PatientFormModal: React.FC<PatientFormModalProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  return (
    <Modal
      open={isOpen}
      onOpenChange={(open) => !open && onClose()}
      size="md"
      hideCloseButton={false}
      disableOutsideClick={true}
    >
      {children}
    </Modal>
  );
};
